import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    municipios: [],
  },

  getters: {
    getMunicipios: (state) => state.municipios,
  },

  mutations: {
    SET_MUNICIPIOS(state, municipios) {
      state.municipios = municipios;
    },
  },

  actions: {
    async fetchMunicipios({ commit }) {
      await axios
        .get('EonCloud/municipios')
        .then((response) => {
          commit('SET_MUNICIPIOS', response.data.data);
        });
    },
  },
};
